module.exports = __webpack_public_path__ + "img/Ouest-France_logo.46f0092c.svg";